<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="save" :loading="btnLoading" v-if="+psu.projectbmamt === 0 || +radio===2">保存</el-button>

      <!-- <el-button @click="alipaypay" v-if="+psu.projectbmamt > 0 && !psu.psubmpaytradeno">支付宝支付</el-button>
      <el-button @click="tenpay" v-if="+psu.projectbmamt > 0 && !psu.psubmpaytradeno">微信支付</el-button> -->
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div>
      <el-form :model="psu" label-position="right" class="mainfrom">
        <el-form-item label="项目编号" class="from-value">
          {{psu.projectcode}}
        </el-form-item>
        <el-form-item label="项目名称" class="from-value">
          {{psu.projectname}}
        </el-form-item>
        <el-form-item label="报名费" class="from-value">
          {{setThousand(psu.projectbmamt)}}
        </el-form-item>
        <el-form-item label="支付状态">
          {{psu.psubmpaytype !== null ?'已支付':'未支付'}}
        </el-form-item>
        <div v-if="psu.psubmpaytype === null && +psu.projectbmamt > 0">
          <el-form-item style="margin-left:35px;" v-if="psu.psubmpaytype === null">
            <el-radio-group v-model="radio">
              <el-radio :label="1">线上支付</el-radio>
              <el-radio :label="2">线下支付</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item  style="margin-left:35px;" v-if="+radio === 1">
            <div class="btn">
              <el-button @click="alipaypay" v-if="+psu.projectbmamt > 0 && !psu.psubmpaytradeno">支付宝支付</el-button>
              <el-button @click="tenpay" v-if="+psu.projectbmamt > 0 && !psu.psubmpaytradeno">微信支付</el-button>
            </div>
          </el-form-item>
          <el-form-item v-if="+radio === 2">
            <div>
              <el-form-item label="支付凭证" v-if="+psu.projectbmamt > 0" >
                <upload-pic-one @changed='setfile' :picUrl='psu.psubmpayurl' folderName='web' text="选择图片"></upload-pic-one>
              </el-form-item>
            </div>
          </el-form-item>
        </div>
        <div v-if="psu.psubmpaytype !== null">
          <div v-if="psu.psubmpaytradeno">
            <el-form-item label="支付渠道">
              {{psu.psubmpaytype == 1?'支付宝支付':'微信支付'}}
            </el-form-item>
            <el-form-item label="交易单号">
              {{psu.psubmpaytradeno}}
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item label="支付凭证" v-if="+psu.projectbmamt > 0" >
              <upload-pic-one @changed='setfile' :picUrl='psu.psubmpayurl' folderName='web' text="选择图片"></upload-pic-one>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <paycommon :type="Paytype" :visible="visible" :order="order" @cacle="cacle">
        <div class="wxmessage">
          <div class="wxmessageItem">
            <div class="itemName">交易金额</div>
            <div class="itemPrice"><span class="priceText">{{psu.projectbmamt}}</span>元</div>
          </div>
          <div class="wxmessageItem">
            <div class="itemName">支付方式</div>
            <div class="itemPrice">微信支付</div>
          </div>
          <div class="wxmessageItem">
            <div class="itemName">交易号</div>
            <div class="itemPrice">{{order.outTradeNo}}</div>
          </div>
        </div>
      </paycommon>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import paycommon from  '../../components/core/paycommon'
  export default {
    name: "psuBmPayForm",
    data () {
      return {
        userid:this.$store.getters.loginUser.userid,
        project: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        psuid:this.$route.params.form.psuid,
        psu: {},
        psuisopenList: [],
        psuflgList: [],
        order: {
          outTradeNo: "",   //订单号
          productCode: 'FAST_INSTANT_TRADE_PAY',
          totalAmount: '',   //金额：微信单位（分），支付宝单位（元）
          subject: '',   //商品名
          body: '',   //商品信息
          passback_params: ''    //项目id_用户id_保证金0或者服务费1
        },
        visible:false,
        Paytype:0,
        radio:1,
        Interval:null
      }
    },
    created () {
      this.init()
      this.getList()
    },
    activated () {
      this.init()
    },
    moutend () {
      this.init()
    },
    watch: {},
    filters: {},
    components: {uploadPicOne,paycommon},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
    },
    methods: {
      cacle (val) {
        this.visible = val
        clearInterval(this.Interval) 
        
      },
      setThousand (value) {
        return utils.comdify(value)
      },
      btnClick (code) {
        this.$emit(code)
      },
      async getList(){
        this.loading = true
        let data = await request({
            url: '/xmgl/project/searchPay',
            method: "get",
            params:{psuid : this.psuid}
        }).catch(() => {
          this.loading = false
        })
        this.psu = data[0]
        this.loading = false
      },
      async init () {
        this.psuid = this.$route.params.form.psuid
        this.psu = {}
        this.userid = this.$store.getters.loginUser.userid
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
      },
      async setfile (path) {
        this.psu.psubmpayurl = path.replace(this.uploadAddr, '')
      },
      async save () {
        if(this.psu.psubmpaytype !== null){
          this.$message.warning('已支付')
          return
        }
        if(+this.psu.projectbmamt > 0 && !this.psu.psubmpayurl){
          this.$message.warning('请上传支付凭证！')
          return
        }
        this.psu.psubmpayuserid = this.userid
        this.psu.psubmpaytype = 3
        let data = await request({
          url: '/xmgl/project/savePsuBmPay',
          method: "post",
          data: this.psu
        })

        if (data.issuccess === 1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.visible = false
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'psuIndex'})
      },
      async alipaypay(){
        if(this.psu.psubmpaytradeno){
          this.$message.warning('已支付')
          return
        }
        if(this.psu.psubmpayurl){
          this.$message.warning('凭证已上传')
          return
        }
        let payflg = true
        //psuid_项目id_用户id_报名费0保证金1或者服务费2///this.project.projectno
        let passback_params = this.psu.psuid+'_' + this.psu.psuprojectid + '_' + this.userid +'_' + 0
        this.Paytype = 1
        this.order.outTradeNo = this.project.projectno + '001' + this.userid + parseInt(Math.random()*(100+1),10)
        this.order.subject = this.psu.projectname
        this.order.totalAmount = this.psu.projectbmamt
        this.order.passback_params = passback_params
        this.visible = true
        this.Interval = setInterval(async () => {
            let data = await request({
              url: '/xmgl/project/searchPay',
              method: "get",
              params:{psuid : this.psu.psuid}
            })
            if(data[0].psubmpaytradeno){
              this.cacle(false)
              this.getList()
              if(payflg === true)
                this.$message.success('支付成功')
                payflg = false
              return
            }
        }, 500);
      },
      async tenpay(){
        if(this.psu.psubmpaytradeno){
          this.$message.warning('已支付')
          return
        }
        if(this.psu.psubmpayurl){
          this.$message.warning('凭证已上传')
          return
        }
        let payflg = true
        let passback_params = this.psu.psuid+'_'+this.psu.psuprojectid+'_'+ this.userid + '_' + 0
        this.Paytype = 2
        this.order.outTradeNo = this.project.projectno + '001' + this.userid + parseInt(Math.random()*(100+1),10)
        this.order.subject = this.psu.projectname
        this.order.totalAmount = this.psu.projectbmamt * 100
        this.order.passback_params = passback_params
        this.order.body = this.psu.projectname
        this.visible = true
        this.Interval = setInterval(async () => {
            let data = await request({
              url: '/xmgl/project/searchPay',
              method: "get",
              params:{psuid : this.psuid}
            })
            if(data[0].psubmpaytradeno){
              this.cacle(false)
              this.getList()
              if(payflg === true)
                this.$message.success('支付成功')
              payflg = false
              return
            }
        }, 500);
      }
    },
    destroyed(){
      clearInterval(this.Interval)
    }
  }
</script>

<style scoped>
.wxmessage{
  margin-top:20px;
  border: 1px solid #c8c8c8;
  width: 100%;
  font: 12px/1.5 tahoma,arial,宋体;
}
.wxmessageItem{
  display: flex;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #c8c8c8;
}
.wxmessageItem:nth-child(3){
  border-bottom: none;
}
.itemName{
  width: 100px;
  flex: 0 0 100px;
  background-color: #fbfbfb;
  border-right: 1px solid #c8c8c8;
  text-align: right;
  padding:5px;
}
.itemPrice{
  width: 650px;
  flex: 0 0 650px;
  padding:5px;
}
.priceText{
  font-size: 22px;
  color: #f60;
  font-weight: bold;
}
</style>
